<div class="container">
    <ng-container *ngIf="!error">
        <!-- Sticky Header with Date Info and Filter Tabs -->
        <div class="sticky-header">
            <div class="top-bar" fxLayout="row wrap" fxLayoutAlign="center ">
                <!-- Left side: Date Info -->
                                    <div fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div fxFlex="column">
                            <div *ngIf="standaloneView" class="venue-name">{{venueData.name}}</div>
                            <div class="date-range-display" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                <button mat-icon-button 
                                        color="primary" 
                                        (click)="goToPreviousWeekPeriod()"
                                        class="date-navigation-btn"
                                        *ngIf="!standaloneView">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>
                                
                                <span>
                                    <strong id="header-date-start">
                                        {{ dateRangeOg.start || 'Not defined' }}
                                    </strong>
                                    to
                                    <strong id="header-date-end">
                                        {{ dateRangeOg.end || 'Not defined' }}
                                    </strong>
                                </span>
                                
                                <button mat-icon-button 
                                        color="primary" 
                                        (click)="goToNextWeekPeriod()"
                                        [disabled]="isNextWeekDisabled()"
                                        class="date-navigation-btn"
                                        *ngIf="!standaloneView">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                <!-- Right side: Action Buttons -->
<!--                <div>-->
<!--                    <button mat-stroked-button (click)="openShareDialog()" *ngIf="!standaloneView">-->
<!--                        <mat-icon>share</mat-icon>-->
<!--                    </button>-->
<!--                    <button mat-stroked-button (click)="openHelpDialog()" style="margin-left: 10px;">-->
<!--                        <mat-icon>help</mat-icon>-->
<!--                    </button>-->
<!--                </div>-->
            </div>

            <!-- New Filter Tabs -->
            <div class="filter-tabs-container">
                <mat-button-toggle-group #group="matButtonToggleGroup" [value]="activeFilterTab" (change)="selectFilterTab($event.value)">
                    <mat-button-toggle *ngFor="let tab of filterTabs" [value]="tab" [aria-label]="tab.name">
                        {{tab.name}}
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

        <!-- Main Content -->
        <div class="main-content" 
             (touchstart)="onTouchStart($event)" 
             (touchend)="onTouchEnd($event)"
             (touchmove)="onTouchMove($event)">
            <!-- Summary Cards -->
            <div class="summary-row" *ngIf="!(csvData.length === 0)">
                <mat-card class="week-selector-card summary-card" fxLayoutAlign="center center" fxLayout="column" *ngIf="viewMode === 'week'">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <h3 class="summary-title">Selected week</h3>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <button mat-icon-button color="primary" [disabled]="selectedWeekIndex <= 0" (click)="goToPreviousWeek()" *ngIf="!standaloneView">
                            <mat-icon>chevron_left</mat-icon>
                        </button>

                        <div fxLayout="column" fxLayoutAlign="center center">
                            <div class="summary-value" style="white-space: pre-line;">{{weekOptions[selectedWeekIndex].viewValue}}</div>
                        </div>

                        <button mat-icon-button color="primary" [disabled]="selectedWeekIndex >= weeks.length - 1" (click)="goToNextWeek()" *ngIf="!standaloneView">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </mat-card>

                <!-- Combined Total Sales + Sales Pie Chart -->
                <mat-card class="summary-card sales-summary-combined-card">
                  <mat-card-content>
                    <div style="display: flex; align-items: flex-start; gap: 12px; width: 100%; justify-content: space-between;">
                      <!-- Sales Info -->
                      <div class="summary-content" style="min-width: 90px; text-align: left;">
                        <div class="summary-icon">
                          <mat-icon color="primary" [matTooltip]="tooltipService.getSalesTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">currency_pound</mat-icon>
                        </div>
                        <h3 class="summary-title" [matTooltip]="tooltipService.getSalesTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Total Sales</h3>
                        <div class="summary-value">
                          <span>£{{ summaryData.totalSales >= 1000
                          ? (summaryData.totalSales / 1000).toFixed(1) + 'k'
                          : summaryData.totalSales.toFixed(2) }}</span>
                          <div *ngIf="summaryData.salesComparison !== 'equal'" class="sales-comparison">
                            <mat-icon *ngIf="summaryData.salesComparison === 'up'" 
                                     class="sales-comparison-arrow sales-up" 
                                     color="accent">trending_up</mat-icon>
                            <mat-icon *ngIf="summaryData.salesComparison === 'down'" 
                                     class="sales-comparison-arrow sales-down" 
                                     color="warn">trending_down</mat-icon>
                            <span class="sales-difference" 
                                  [class.sales-up]="summaryData.salesComparison === 'up'"
                                  [class.sales-down]="summaryData.salesComparison === 'down'">
                              £{{ (summaryData.totalSales - summaryData.total3WeekAvg) >= 1000
                                ? ((summaryData.totalSales - summaryData.total3WeekAvg) / 1000).toFixed(1) + 'k'
                                : (summaryData.totalSales - summaryData.total3WeekAvg).toFixed(0) }}
                            </span>
                          </div>
                        </div>
                        <div class="summary-detail">
                          Avg: £{{ summaryData.avgSales.toFixed(2) }}
                        </div>
                      </div>
                      <!-- (Optional: Add more info here if needed) -->
                    </div>
                    <!-- Bar Chart at the bottom -->
                    <div class="sales-bar-chart" style="margin-top: 12px;">
                      <ng-container *ngIf="summaryData && getTotalCount(summaryData.salesByLabel) > 0">
                        <div class="bar-chart-track">
                          <ng-container *ngFor="let category of pieChartSliceOrders['sales']">
                            <div class="bar-segment"
                                 *ngIf="summaryData.salesByLabel[category] > 0"
                                 [style.width.%]="getDistributionPercentage(summaryData.salesByLabel[category], getTotalCount(summaryData.salesByLabel))"
                                 [style.background]="getBgColorSingle('sales', category)">
                            </div>
                          </ng-container>
                        </div>
                        <!-- Sales Bar Chart Card legend -->
                        <div class="bar-legend">
                          <ng-container *ngFor="let category of pieChartSliceOrders['sales']">
                            <span class="legend-item" *ngIf="summaryData.salesByLabel[category] > 0">
                              <span class="legend-percent-box"
                                    [style.background]="getBgColorSingle('sales', category)"
                                    [style.color]="getContrastTextColor(getBgColorSingle('sales', category))">
                                {{ getDistributionPercentage(summaryData.salesByLabel[category], getTotalCount(summaryData.salesByLabel)) | number:'1.0-0' }}%
                              </span>
                            </span>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </mat-card-content>
                </mat-card>

                <!-- QPI Bar Chart Card -->
                <mat-card class="summary-card qpi-summary-combined-card">
                  <mat-card-content>
                    <div style="display: flex; align-items: flex-start; gap: 12px; width: 100%; justify-content: space-between;">
                      <!-- QPI Info -->
                      <div class="summary-content" style="min-width: 90px; text-align: left;">
                        <div class="summary-icon">
                          <mat-icon color="primary" [matTooltip]="tooltipService.getQPITooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">speed</mat-icon>
                        </div>
                        <h3 class="summary-title" [matTooltip]="tooltipService.getQPITooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">QPI</h3>
                        <div class="summary-value">
                          <span>{{ (summaryData.avgQPI * 100) | number:'1.0-1' }}%</span>
                          <div *ngIf="summaryData.qpiComparison !== 'equal'" class="sales-comparison">
                            <mat-icon *ngIf="summaryData.qpiComparison === 'up'" 
                                     class="sales-comparison-arrow sales-up" 
                                     color="accent">trending_up</mat-icon>
                            <mat-icon *ngIf="summaryData.qpiComparison === 'down'" 
                                     class="sales-comparison-arrow  sales-down" 
                                     color="warn">trending_down</mat-icon>
                            <span class="sales-difference" 
                                  [class.sales-up]="summaryData.qpiComparison === 'up'"
                                  [class.sales-down]="summaryData.qpiComparison === 'down'">
                              {{ ((summaryData.avgQPI - summaryData.avgQPI3WeekAvg) * 100) | number:'1.0-1' }}%
                            </span>
                          </div>
                        </div>
                        <div class="summary-detail">
                          Avg Efficiency
                        </div>
                      </div>
                      <!-- (Optional: Add more info here if needed) -->
                    </div>
                    <!-- Bar Chart at the bottom -->
                    <div class="qpi-bar-chart" style="margin-top: 12px;">
                      <ng-container *ngIf="summaryData && getTotalCount(summaryData.qpiByLabel) > 0">
                        <div class="bar-chart-track">
                          <ng-container *ngFor="let category of pieChartSliceOrders['qpi']">
                            <div class="bar-segment"
                                 *ngIf="summaryData.qpiByLabel[category] > 0"
                                 [style.width.%]="getDistributionPercentage(summaryData.qpiByLabel[category], getTotalCount(summaryData.qpiByLabel))"
                                 [style.background]="getBgColorSingle('qpi', category)">
                            </div>
                          </ng-container>
                        </div>
                        <!-- QPI Bar Chart Card legend -->
                        <div class="bar-legend">
                          <ng-container *ngFor="let category of pieChartSliceOrders['qpi']">
                            <span class="legend-item" *ngIf="summaryData.qpiByLabel[category] > 0">
                              <span class="legend-percent-box"
                                    [style.background]="getBgColorSingle('qpi', category)"
                                    [style.color]="getContrastTextColor(getBgColorSingle('qpi', category))">
                                {{ getDistributionPercentage(summaryData.qpiByLabel[category], getTotalCount(summaryData.qpiByLabel)) | number:'1.0-0' }}%
                              </span>
                            </span>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </mat-card-content>
                </mat-card>

                <!-- Experience Bar Chart Card -->
                <mat-card class="summary-card experience-summary-combined-card">
                  <mat-card-content>
                    <div style="display: flex; align-items: flex-start; gap: 12px; width: 100%; justify-content: space-between;">
                      <!-- Experience Info -->
                      <div class="summary-content" style="min-width: 90px; text-align: left;">
                        <div class="summary-icon">
                          <mat-icon color="primary" [matTooltip]="tooltipService.getExperienceTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">timer</mat-icon>
                        </div>
                        <h3 class="summary-title" [matTooltip]="tooltipService.getExperienceTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Experience</h3>
                        <div class="summary-value">
                          <span>{{ summaryData.avgExperienceDuration | number:'1.0-1' }}s</span>
                          <div *ngIf="summaryData.experienceComparison !== 'equal'" class="sales-comparison">
                            <mat-icon *ngIf="summaryData.experienceComparison === 'up'" 
                                     class="sales-comparison-arrow sales-up" 
                                     color="accent">trending_down</mat-icon>
                            <mat-icon *ngIf="summaryData.experienceComparison === 'down'" 
                                     class="sales-comparison-arrow sales-down" 
                                     color="warn">trending_up</mat-icon>
                            <span class="sales-difference" 
                                  [class.sales-up]="summaryData.experienceComparison === 'up'"
                                  [class.sales-down]="summaryData.experienceComparison === 'down'">
                              {{ (summaryData.avgExperienceDuration - summaryData.avgExperienceDuration3WeekAvg) | number:'1.0-1' }}s
                            </span>
                          </div>
                        </div>
                        <div class="summary-detail">
                          Avg Duration
                        </div>
                      </div>
                      <!-- (Optional: Add more info here if needed) -->
                    </div>
                    <!-- Bar Chart at the bottom -->
                    <div class="experience-bar-chart" style="margin-top: 12px;">
                      <ng-container *ngIf="summaryData && getTotalCount(summaryData.experienceByLabel) > 0">
                        <div class="bar-chart-track">
                          <ng-container *ngFor="let category of pieChartSliceOrders['experience']">
                            <div class="bar-segment"
                                 *ngIf="summaryData.experienceByLabel[category] > 0"
                                 [style.width.%]="getDistributionPercentage(summaryData.experienceByLabel[category], getTotalCount(summaryData.experienceByLabel))"
                                 [style.background]="getExperienceColor(category)">
                            </div>
                          </ng-container>
                        </div>
                        <!-- Experience Bar Chart Card legend -->
                        <div class="bar-legend">
                          <ng-container *ngFor="let category of pieChartSliceOrders['experience']">
                            <span class="legend-item" *ngIf="summaryData.experienceByLabel[category] > 0">
                              <span class="legend-percent-box"
                                    [style.background]="getExperienceColor(category)"
                                    [style.color]="getContrastTextColor(getExperienceColor(category))">
                                {{ getDistributionPercentage(summaryData.experienceByLabel[category], getTotalCount(summaryData.experienceByLabel)) | number:'1.0-0' }}%
                              </span>
                            </span>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </mat-card-content>
                </mat-card>

                <!-- Staffing Bar Chart Card -->
                <mat-card class="summary-card staffing-summary-combined-card">
                  <mat-card-content>
                    <div style="display: flex; align-items: flex-start; gap: 12px; width: 100%; justify-content: space-between;">
                      <!-- Staffing Info -->
                      <div class="summary-content" style="min-width: 90px; text-align: left;">
                        <div class="summary-icon">
                          <mat-icon color="primary" [matTooltip]="tooltipService.getStaffingTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">people</mat-icon>
                        </div>
                        <h3 class="summary-title" [matTooltip]="tooltipService.getStaffingTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Staffing</h3>
                        <div class="summary-value">
                          <span>{{ (summaryData.avgCoL * 100) | number:'1.0-1' }}%</span>
                          <div *ngIf="summaryData.staffingComparison !== 'equal'" class="sales-comparison">
                            <mat-icon *ngIf="summaryData.staffingComparison === 'up'" 
                                     class="sales-comparison-arrow sales-up" 
                                     color="accent">trending_down</mat-icon>
                            <mat-icon *ngIf="summaryData.staffingComparison === 'down'" 
                                     class="sales-comparison-arrow sales-down" 
                                     color="warn">trending_up</mat-icon>
                            <span class="sales-difference" 
                                  [class.sales-up]="summaryData.staffingComparison === 'up'"
                                  [class.sales-down]="summaryData.staffingComparison === 'down'">
                              {{ ((summaryData.avgCoL - summaryData.avgCoL3WeekAvg) * 100) | number:'1.0-1' }}%
                            </span>
                          </div>
                        </div>
                        <div class="summary-detail" [matTooltip]="tooltipService.getColTooltip()" matTooltipPosition="above" matTooltipClass="weekly-tooltip">
                          Avg CoL
                        </div>
                      </div>
                      <!-- (Optional: Add more info here if needed) -->
                    </div>
                    <!-- Bar Chart at the bottom -->
                    <div class="staffing-bar-chart" style="margin-top: 12px;">
                      <ng-container *ngIf="summaryData && getTotalCount(summaryData.detailedStaffingByClass) > 0">
                        <div class="bar-chart-track">
                          <ng-container *ngFor="let category of pieChartSliceOrders['detailedStaffing']">
                            <div class="bar-segment"
                                 *ngIf="summaryData.detailedStaffingByClass[category] > 0"
                                 [style.width.%]="getDistributionPercentage(summaryData.detailedStaffingByClass[category], getTotalCount(summaryData.detailedStaffingByClass))"
                                 [style.background]="getBgColorSingle('staffing', formatStaffingLabel(category))">
                            </div>
                          </ng-container>
                        </div>
                        <!-- Staffing Bar Chart Card legend -->
                        <div class="bar-legend">
                          <ng-container *ngFor="let category of pieChartSliceOrders['detailedStaffing']">
                            <span class="legend-item" *ngIf="summaryData.detailedStaffingByClass[category] > 0">
                              <span class="legend-percent-box"
                                    [style.background]="getBgColorSingle('staffing', formatStaffingLabel(category))"
                                    [style.color]="getContrastTextColor(getBgColorSingle('staffing', formatStaffingLabel(category)))">
                                {{ getDistributionPercentage(summaryData.detailedStaffingByClass[category], getTotalCount(summaryData.detailedStaffingByClass)) | number:'1.0-0' }}%
                              </span>
                            </span>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </mat-card-content>
                </mat-card>
            </div>
            <div *ngIf="loading && csvData.length === 0" class="no-data-message">
                <div class="preloader" *ngIf="csvData.length === 0">
                    <div class="spinner">
                        <div class="double-bounce1"></div>
                        <div class="double-bounce2"></div>
                    </div>
                </div>
            </div>
            <div *ngIf="!loading && csvData.length === 0" class="no-data-message">
                <div class="preloader" >
                    <p >No data available. Please try other dates.</p>
                </div>
            </div>
            <!-- Flex container for side-by-side layout -->
            <div class="flex-container" 
                 *ngIf="!(csvData.length === 0) && !loading"
                 [@tabTransition]="animationState">

                <!-- Period Grid (Period View) -->
                <div class="grid-card" [class.with-details]="selectedDay && selectedTimeSlot" *ngIf="viewMode === 'period'">
                    <div *ngIf="filteredData && weekDays && timeSlots && weekDays.length > 0" class="grid-container flipped-grid mat-elevation-z2">
                        <table class="metrics-table flipped-table">
                            <thead>
                            <tr>
                                <th class="time-header">Day</th>
                                <th *ngFor="let time of timeSlots">{{ time }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let day of weekDays.slice().reverse()">
                                <td class="time-cell">
                                    <div class="day-label">
                                        {{ getShortDay(day) }}<br>
                                        <span class="day-date">{{ getDayMonth(day) }}</span>
                                        <ng-container *ngIf="visibleMetrics.sales && getTotalSalesForDay(day) !== null">
                                          <div class="day-total-sales" 
                                               [style.color]="getTotalSalesColorForDay(day)"
                                               style="font-size: 12px; font-weight: 400; margin-top: 2px;">
                                            <ng-container *ngIf="getTotalSalesForDay(day) !== null">
                                              £{{ getTotalSalesForDay(day) >= 1000 ? (getTotalSalesForDay(day) / 1000).toFixed(1) + 'k' : getTotalSalesForDay(day) | number:'1.0-0' }}
                                            </ng-container>
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="visibleMetrics.experience && getWeightedAvgDurationForDay(day) !== null">
                                          <div class="day-total-sales"
                                               [style.color]="getDurationColorForDay(day)"
                                               style="font-size: 12px; font-weight: 400; margin-top: 2px;">
                                            <ng-container *ngIf="getWeightedAvgDurationForDay(day) !== null && getWeightedAvgDuration3WeekForDay(day) !== null">
                                              {{ getWeightedAvgDurationForDay(day) }}s
                                            </ng-container>
                                          </div>
                                        </ng-container>
                                        <ng-container *ngIf="visibleMetrics.staffing && getTotalStaffingCostPctForDay(day) !== null">
                                          <div class="day-total-sales"
                                               [style.color]="getStaffingCostPctColorForDay(day)"
                                               style="font-size: 12px; font-weight: 400; margin-top: 2px;">
                                            <ng-container *ngIf="getTotalStaffingCostPctForDay(day) !== null && getTotalStaffingCostPct3WeekForDay(day) !== null">
                                              {{ getTotalStaffingCostPctForDay(day) }}%
                                            </ng-container>
                                          </div>
                                        </ng-container>
                                    </div>
                                </td>
                                <td *ngFor="let time of timeSlots" class="data-cell">
                                    <!-- Cell rendering -->
                                    <ng-container *ngIf="filteredData[day] && filteredData[day][time]; else emptyCell">
                                        <div
                                                class="metrics-cell"
                                                [style.background]="getCellBackgroundStyle(filteredData[day][time].sales, filteredData[day][time].qpi).background"
                                                (click)="handleSlotSelect(day, time)"
                                                [class.active-cell]="selectedDay === day && selectedTimeSlot === time"
                                                matRipple
                                        >
                                            <!-- Metrics overlay -->
                                            <div class="cell-overlay">
                                                <!-- Top section with values -->
                                                <div class="cell-top">
                                                    <div class="cell-icon" *ngIf="visibleMetrics.sales">
                                                        <mat-icon [style.color]="getBgColorSingle('sales', filteredData[day][time].sales.label)" 
                                                                  [matTooltip]="tooltipService.getSalesLabelTooltip(filteredData[day][time].sales.label)" 
                                                                  matTooltipPosition="above" matTooltipClass="weekly-tooltip">currency_pound</mat-icon>
                                                    </div>
                                                    <div class="cell-icon" *ngIf="visibleMetrics.experience">
                                                        <mat-icon [style.color]="filteredData[day][time].experience.color" 
                                                                  [matTooltip]="tooltipService.getExperienceLabelTooltip(filteredData[day][time].experience.label)" 
                                                                  matTooltipPosition="above" matTooltipClass="weekly-tooltip">sentiment_satisfied</mat-icon>
                                                    </div>
                                                    <div class="cell-icon" *ngIf="visibleMetrics.staffing">
                                                        <mat-icon [style.color]="filteredData[day][time].staffing.color" 
                                                                  [matTooltip]="tooltipService.getStaffingLabelTooltip(filteredData[day][time].staffing.label)" 
                                                                  matTooltipPosition="above" matTooltipClass="weekly-tooltip">people</mat-icon>
                                                    </div>
                                                    <!-- More Sales indicator in top right corner -->
                                                    <div *ngIf="filteredData[day][time].qpi.moreSales != null"
                                                         class="cell-moreSales-top-right"
                                                         [style.background-color]="getMoreSalesColor(filteredData[day][time].qpi.moreSales)">
                                                        <mat-icon>currency_pound</mat-icon>
                                                    </div>
                                                </div>

                                                <!-- Bottom section with icons -->
                                                <div class="cell-bottom">
                                                    <div class="cell-value" *ngIf="visibleMetrics.sales">
                                                        <div class="comparison-arrow-top">
                                                            <mat-icon *ngIf="isSalesAboveBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-up" 
                                                                     color="accent">trending_up</mat-icon>
                                                            <mat-icon *ngIf="isSalesBelowBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-down" 
                                                                     color="warn">trending_down</mat-icon>
                                                        </div>
                                                        £{{ filteredData[day][time].sales.value >= 1000 ?
                                                        (filteredData[day][time].sales.value/1000).toFixed(1) + 'k' :
                                                        filteredData[day][time].sales.value.toFixed(0) }}
                                                        <mat-icon *ngIf="filteredData[day][time].sales.prediction === 'up' && visibleMetrics.salesPrediction">trending_up</mat-icon>
                                                        <mat-icon *ngIf="filteredData[day][time].sales.prediction === 'same' && visibleMetrics.salesPrediction">trending_flat</mat-icon>
                                                        <mat-icon *ngIf="filteredData[day][time].sales.prediction === 'down' && visibleMetrics.salesPrediction">trending_down</mat-icon>
                                                    </div>
                                                    <div class="cell-value" *ngIf="visibleMetrics.experience && !visibleMetrics.sales">
                                                        <div class="comparison-arrow-top">
                                                            <mat-icon *ngIf="isExperienceBetterThanBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-up" 
                                                                     color="accent">trending_down</mat-icon>
                                                            <mat-icon *ngIf="isExperienceWorseThanBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-down" 
                                                                     color="warn">trending_up</mat-icon>
                                                        </div>
                                                        {{ filteredData[day][time].experience.durations ? 
                                                        filteredData[day][time].experience.durations.toFixed(0) + 's' : 
                                                        'N/A' }}
                                                    </div>
                                                    <div class="cell-value" *ngIf="visibleMetrics.staffing && !visibleMetrics.sales && !visibleMetrics.experience">
                                                        <div class="comparison-arrow-top">
                                                            <mat-icon *ngIf="isStaffingBetterThanBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-up" 
                                                                     color="accent">trending_down</mat-icon>
                                                            <mat-icon *ngIf="isStaffingWorseThanBaseline(filteredData[day][time])" 
                                                                     class="comparison-arrow comparison-down" 
                                                                     color="warn">trending_up</mat-icon>
                                                        </div>
                                                        {{ filteredData[day][time].staffing.col ? 
                                                        (filteredData[day][time].staffing.col * 100).toFixed(1) + '%' : 
                                                        'N/A' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #emptyCell>
                                        <div class="empty-cell"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style="text-align:center; margin-top: 16px; margin-bottom: 16px;">
                        <button mat-stroked-button color="primary" (click)="extendDateRangePastByOneWeek()" *ngIf="!standaloneView">
                            Show 1 more week in the past
                        </button>
                    </div>
                </div>

                <!-- Slot Details Section (as side panel) -->
                <div *ngIf="selectedDay && selectedTimeSlot && filteredData && filteredData[selectedDay][selectedTimeSlot] && !isSmallScreen()"
                     class="slot-details-sidebar">
                    <app-slot-details
                        [slot]="filteredData[selectedDay][selectedTimeSlot]"
                        [visibleMetrics]="{ sales: true, qpi: true, experience: true, staffing: true, moreSales: true }"
                        [showRawData]="showRawData"
                        [showCloseButton]="true"
                        (close)="closeSlotDetails()">
                    </app-slot-details>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Error Message -->
    <div *ngIf="error" class="no-data-container mat-elevation-z2">
        <h2>Error loading this shared page</h2>
        <p>{{errorMessage}}</p>
    </div>
</div>
